export default "__VITE_ASSET__ClHWXsgV__"